<template>
  <oie-base-button
    css-classes="button--with-border button--blue checkout-next-step"
    :text="text"
    :disabled="disabled"
    @click="nextStep">
  </oie-base-button>
</template>

<script>
export default {
  props: {
    componentIndex: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    pushGaDataHandler: {
      type: Function,
      default: undefined
    }
  },
  methods: {
    nextStep() {
      this.publish(`checkout-wizard-step-${this.componentIndex}`, this.componentIndex)

      if (this.pushGaDataHandler) {
        this.pushGaDataHandler()
      }
    }
  }
}
</script>

<style lang="scss">
.checkout-next-step {
  align-self: flex-start;
}

.checkout-sign-up .checkout-next-step {
  margin: 0;
  margin-top: measure(double);
}
</style>
